"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuickFactPrice = exports.getQuickFactAnnualPrice = exports.getQuickFactAccessToAttorneySupport = void 0;
var _estatePlanning = require("@nerdwallet/marketplace/drivers/estate-planning");
var getQuickFactAccessToAttorneySupport = function getQuickFactAccessToAttorneySupport(offer) {
  return (0, _estatePlanning.getDriverAccessToAttorneySupport)(offer);
};
exports.getQuickFactAccessToAttorneySupport = getQuickFactAccessToAttorneySupport;
var getQuickFactAnnualPrice = function getQuickFactAnnualPrice(offer) {
  return (0, _estatePlanning.getDriverAnnualPrice)(offer);
};
exports.getQuickFactAnnualPrice = getQuickFactAnnualPrice;
var getQuickFactPrice = function getQuickFactPrice(offer) {
  return (0, _estatePlanning.getDriverPrice)(offer);
};
exports.getQuickFactPrice = getQuickFactPrice;